import {
  FlatHierarchy,
  IMemberDepricated,
  IPNSProps,
  IProjectMcBimSettings,
} from "@mctypes/global.types";
import Axios from "axios";

export const doGetProjectMembers = async (projectId: string): Promise<IMemberDepricated[]> => {
  try {
    const resp = await Axios.get(`/api/project/${projectId}/members`);
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doCheckIfUserIsMemberOfProject = async (projectId: string): Promise<IMemberDepricated> => {
  try {
    const projectFetch = await Axios.get(`/api/project/${projectId}/user/is-member`);
    return projectFetch.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doUpdateMemberDisciplinInProject = async (
  projectId: string,
  memberId: string,
  disciplin: string,
  removeDiscipline?: boolean,
) => {
  try {
    const resp = await Axios.put(
      `/api/project/${projectId}/member/${memberId}/disciplin/${disciplin}`,
      removeDiscipline === true ? { removeDiscipline } : {},
    );
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doUpdateMemberIsPassive = async (projectId: string, memberId: string, isPassive: boolean) => {
  try {
    const resp = await Axios.put(`/api/project/${projectId}/member/${memberId}/isPassive/${isPassive}`);
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};
export const doUpdateMemberAttribute = async (
  projectId: string,
  memberId: string,
  attribute: string,
  value: string | number | boolean,
) => {
  try {
    const resp = await Axios.put(`/api/project/${projectId}/member/update-attribute`, { memberId, attribute, value });
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doUpdateMemberGroupInProject = async (projectId: string, memberId: string, group: string) => {
  try {
    const resp = await Axios.put(`/api/project/${projectId}/member/${memberId}/group/${group}`);
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doUpdateMcBim = async (
  projectId: string,
  mcbim: IProjectMcBimSettings,
): Promise<IProjectMcBimSettings> => {
  try {
    const resp = await Axios.put(`/api/project/${projectId}/mcbim`, { mcbim });
    return Promise.resolve(resp.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const doUpdatePns = async (
  projectId: string,
  flatHierarchy: FlatHierarchy<IPNSProps>,
): Promise<FlatHierarchy<IPNSProps>> => {
  try {
    const resp = await Axios.put(`/api/project/${projectId}/pns`, flatHierarchy);
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doGetProjectPnsItems = async (projectId: string): Promise<FlatHierarchy<IPNSProps>> => {
  try {
    const resp = await Axios.get(`/api/project/${projectId}/pnsItems`);
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doAddAdminUserToProject = async (userId: string, projectId: string): Promise<void> => {
  try {
    const resp = await Axios.post(`/api/project/add-user`, { userId, projectId });
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};
